import {useAppContext} from "../../utils/AppContext";

const Steps = () => {
    const {
        projectData,
        screenSize,} = useAppContext();

    // Styles Configuration //
    const stepsContainer = (!screenSize)? 'steps-container' : `steps-container steps-container${screenSize}`;
    const sectionTitle = (!screenSize)? "section-title" : `section-title section-title${screenSize}`;
    const stepsItemsContainer = (!screenSize)? "steps-items-container" : `steps-items-container steps-items-container${screenSize}`;
    const stepItemContainer = (!screenSize)? "step-item-container" : `step-item-container step-item-container${screenSize}`;
    const largeNumber = (!screenSize)? "large-number" : `large-number large-number${screenSize}`;
    const stepItemContentContainer = (!screenSize)? "step-item-content-container" : `step-item-content-container step-item-content-container${screenSize}`;
    const itemTitle = (!screenSize)? "item-title" : `item-title item-title${screenSize}`;
    const smallTextLight = (!screenSize)? "small-text-light" : `small-text-light small-text-light${screenSize}`;

    const stepsItem = ({item, index}) => {
        return (
            <div
                className={stepItemContainer}
                key={index}
            >
                <div>
                    <span className={largeNumber}>{item.number}.</span>
                </div>
                <div className={stepItemContentContainer}>
                    <h4 className={itemTitle}>{item.title}</h4>
                    <p className={smallTextLight}>{item.description}</p>
                </div>
            </div>
        );
    };

    return (
        <div className={stepsContainer}>
            <h2 className={sectionTitle}>{projectData.steps.title}</h2>
            <div className={stepsItemsContainer}>
                {projectData.steps.items.map((item, index) => (
                    stepsItem({item, index})
                ))}
            </div>
        </div>
    );

};

export default Steps;